import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
import BookService from '@tencent/vft-ui/src/MagicUi/BookButton/services';
import { mapState } from 'vuex';
import moment from 'moment';
export default {
  data: function data() {
    return {
      actId: 4239,
      moduleId: 8904,
      status: {
        is_book: 0
      }
    };
  },
  computed: _objectSpread({}, mapState(['isLogin', 'now']), {
    bg: function bg() {
      var _this = this;

      var bg = this.setting.背景图.filter(function (item) {
        var start = moment(item.开始时间).valueOf();
        var end = moment(item.结束时间).valueOf();
        return _this.now >= start && _this.now < end;
      });
      return bg && bg[0] && bg[0].图 || '';
    }
  }),
  methods: {
    bookHandler: function () {
      var _bookHandler = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isLogin) {
                  _context.next = 3;
                  break;
                }

                this._openLogin();

                return _context.abrupt("return", false);

              case 3:
                if (!this.status.is_book) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return BookService.book(this.actId, this.moduleId);

              case 8:
                res = _context.sent;
                data = res.data;

                if (data.is_book === 1) {
                  this.toast('预约成功');
                }

                this.status = data;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                this.alert('网络异常，请稍后重试！');

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 14]]);
      }));

      function bookHandler() {
        return _bookHandler.apply(this, arguments);
      }

      return bookHandler;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.isLogin) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", false);

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return BookService.init(this.actId, this.moduleId);

            case 5:
              res = _context2.sent;
              this.status = res.data;
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              this.$emit('error', _context2.t0);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[2, 9]]);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  settingKey: '专场福蛋好礼',
  setting: {
    背景图: {
      type: 'array',
      default: [{
        图: '//puep.qpic.cn/vupload/0/20190115_1547553106422_5qbgq1lzc4.png/0',
        开始时间: '2019-02-03 23:59:59',
        结束时间: '2019-02-03 23:59:59'
      }],
      items: {
        type: 'object',
        properties: {
          图: '//puep.qpic.cn/vupload/0/20190115_1547553106422_5qbgq1lzc4.png/0',
          开始时间: {
            type: 'datetime',
            default: '2019-02-03 23:59:59'
          },
          结束时间: {
            type: 'datetime',
            default: '2019-02-03 23:59:59'
          }
        }
      }
    }
  }
};